import { render, staticRenderFns } from "./CardAgent.vue?vue&type=template&id=4fcc9dbf"
import script from "./CardAgent.vue?vue&type=script&lang=js"
export * from "./CardAgent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports